import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import MainPage from './pages/MainPage';
import GlobalHeader from '@/components/common/GlobalHeader';


// https://github.com/aws-amplify/amplify-ui/pull/1024
// eslint-disable-next-line import/no-unresolved
import '@aws-amplify/ui-react/styles.css';


const App: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        {/* <GlobalHeader signOut={() => {}} /> */}
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="*" element={<div>Not Found.</div>} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
